/**
 * ResultList.jsx
 *
 * Sonuç listesini ve özet çubuğunu render eder.
 * SOLID - Single Responsibility: Sadece sonuç listesi düzeninden sorumludur.
 */

import React from "react";
import ResultCard from "./ResultCard";
import EngineBadge from "./EngineBadge";

function ResultList({ results, engine, latencyMs, query, translatedQuery }) {
  if (!results || results.length === 0) {
    return (
      <div className="result-list__empty" role="status">
        <div className="status-message__icon" aria-hidden="true">📭</div>
        <p>
          <strong>"{query}"</strong> sorgusu için sonuç bulunamadı.
        </p>
      </div>
    );
  }

  return (
    <section className="result-list" aria-label="Arama sonuçları">
      {/* Özet çubuğu */}
      <div className="result-list__summary" role="status" aria-live="polite" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <EngineBadge engine={engine} />
          <span className="result-list__count">
            <strong>{results.length}</strong> sonuç bulundu
          </span>
          <span className="result-list__divider" aria-hidden="true">·</span>
          <span className="result-list__latency" title="Toplam işlem süresi">
            {latencyMs.toFixed(2)} ms
          </span>
        </div>
        
        {/* Çeviri Özeti */}
        {translatedQuery && (
          <div className="result-list__translation" style={{ fontSize: '0.875rem', color: '#6b7280', background: '#f3f4f6', padding: '0.25rem 0.75rem', borderRadius: '4px', border: '1px dashed #d1d5db' }}>
            🇬🇧 <strong>Çevrilen Sorgu:</strong> <em>"{translatedQuery}"</em>
          </div>
        )}
      </div>

      {/* Kartlar */}
      <div className="result-list__cards">
        {results.map((result) => (
          <ResultCard
            key={result.chunk_id}
            result={result}
            engine={engine}
          />
        ))}
      </div>
    </section>
  );
}

export default ResultList;
